document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('#MainContent > .shopify-section');
  if (!sections.length) return;

  if (window.Shopify && window.Shopify.designMode) {
    sections.forEach(function (section) {
      section.classList.add('in');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px 150px 0px' });

  sections.forEach(function (section) {
    observer.observe(section);
  });
});

document.addEventListener('shopify:section:load', function (event) {
  if (window.Shopify && window.Shopify.designMode) {
    event.target.classList.add('in');
  }
});
